import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';

type PetInsuranceExample = {
  id: number;
  title: string;
  scenario: string;
  protection: string;
  photoUrl: string;
};

const petInsuranceExamples: PetInsuranceExample[] = [
  {
    id: 1,
    title: "Accidental Injury Treatment",
    scenario: "Your dog is hit by a car and requires emergency surgery and hospitalization.",
    protection: "Pet insurance covers surgery, anesthesia, and post-op care up to the policy limit.",
    photoUrl: "https://source.unsplash.com/400x300/?injured-dog,veterinary"
  },
  {
    id: 2,
    title: "Chronic Illness Care",
    scenario: "Your cat is diagnosed with diabetes and needs ongoing medication and vet visits.",
    protection: "Covers a portion of medication and treatment for chronic conditions.",
    photoUrl: "https://source.unsplash.com/400x300/?cat,vet"
  },
  {
    id: 3,
    title: "Emergency Vet Visit",
    scenario: "Your pet suddenly stops eating and requires emergency diagnostic testing.",
    protection: "Insurance helps pay for emergency exam fees, tests, and treatment.",
    photoUrl: "https://source.unsplash.com/400x300/?dog,clinic"
  }
  // Add more items as needed
];

const InsuranceExample2: React.FC = () => {
  return (
    <Container className="my-4">
      <h2 className="mb-4 text-center">HARD CODED - TO FIX: How Pet Insurance Protects You</h2>
      <Row>
        {petInsuranceExamples.map((example) => (
          <Col md={6} lg={4} className="mb-4" key={example.id}>
            <Card className="h-100 shadow-sm">
              <Card.Img variant="top" src={example.photoUrl} alt={example.title} />
              <Card.Body>
                <Card.Title>{example.id}. {example.title}</Card.Title>
                <Card.Text><strong>Scenario:</strong> {example.scenario}</Card.Text>
                <Card.Text><strong>Protection:</strong> {example.protection}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default InsuranceExample2;
